<template>
  <div class="product-public-list-container">
    <div class="pagination-container">
      <component-pagination/>
    </div>
    <div class="product-public-list" v-if="!apiLoading">
      <div class="card" v-for="product in apiData.results">
        <!-- <div class="logo" @click="renderLogo(product.ProductID)"> -->
        <div class="logo" v-if="product.ProductLogo">
          <!-- <img :src="getLogoFile(product.ProductLogo)" id="logo_rendered"/> -->
          <img :src="getLogoURL(product.ProductLogo)" id="logo_rendered"/>

          <!-- {{ product.ProductLogo }} -->
        <!-- <div class="logo" v-if="product.ProductLogo"> -->
          <!-- <img src="@/assets/company_logos/measurlogic-logo.png" /> -->
          <!-- <img id="logo_rendered" :src="'@/assets/company_logos/' + product.ProductLogo.replace('http://127.0.0.1:8000/api/v1/products/uploads/logos/', '')" /> -->
          <!-- <img src=`${`> -->
          <!-- <img :src="render_img()" id="logo_rendered" /> -->
          <!-- <img :src="product.b64Img" id="logo_rendered" /> -->

          <!-- <span v-if="image_src">
            <img :src="img_src" id="logo_rendered" />
          </span> -->
        </div>
        <div class="card-body">
          <ul>
            <!-- <li class="card-text">
            <strong>Identifier:</strong>
            {{ product.ProductIdentifier }}
            </li>-->
            <li class="card-text">
              <strong>Certification Number:</strong>
              {{ product.CertificationNumber }}
            </li>
            <li class="card-text">
              <strong>Manufacturer Name:</strong>
              {{ product.ManufacturerName }}
            </li>
            <li class="card-text" v-if="product.ProductType">
              <strong>ProductType:</strong>
              {{ product.ProductType }}
            </li>
            <li class="card-text" v-if="product.DeviceProfile">
              <strong>DeviceProfile:</strong>
              {{ product.DeviceProfile }}
            </li>
            <li class="card-text">
              <strong>CertificateType:</strong>
              {{ product.CertificateType }}
            </li>
            <li class="card-text" v-if="product.Products">
              <strong>Products:</strong>
              {{ product.Products }}
            </li>
            <li class="card-text" v-if="product.ModBusModels">
              <strong>ModBusModels:</strong>
              {{ product.ModBusModels }}
            </li>
            <!-- <li class="card-text" v-if="product.ModBusModels">
              <strong>Base64:</strong>
              {{ product.b64Img }}
            </li> -->
            <li class="card-text download-card-text">
              <span class="download-links-container">
                <strong>Download:</strong>

                <a id="download-link-pics" v-if="product.ProductPICS1" :href="getDownloadPICSURL(product.ProductPICS1)">PICS1</a>
                <a id="download-link-pics" v-if="product.ProductPICS2" :href="getDownloadPICSURL(product.ProductPICS2)">PICS2</a>
                <a id="download-link-pics" v-if="product.ProductPICS3" :href="getDownloadPICSURL(product.ProductPICS3)">PICS3</a>
                <a id="download-link-pics" v-if="product.ProductPICS4" :href="getDownloadPICSURL(product.ProductPICS4)">PICS4</a>

                <a id="download-link-certificate"  v-if="product.ProductCertificate1" @click="getCert(product.ProductCertificate1, '1')">Certificate1</a>
                <a id="download-link-certificate"  v-if="product.ProductCertificate2" @click="getCert(product.ProductCertificate2, '2')">Certificate2</a>
                <a id="download-link-certificate"  v-if="product.ProductCertificate3" @click="getCert(product.ProductCertificate3, '3')">Certificate3</a>
                <a id="download-link-certificate"  v-if="product.ProductCertificate4" @click="getCert(product.ProductCertificate4, '4')">Certificate4</a>

                <!-- served from ngninx, but sends you to a different page -->
                <!-- <a id="download-link-certificate"  v-if="product.ProductCertificate1" :href="getDownloadCertURL(product.ProductCertificate1, '1')">Certificate1</a>
                <a id="download-link-certificate"  v-if="product.ProductCertificate2" :href="getDownloadCertURL(product.ProductCertificate2, '2')">Certificate2</a>
                <a id="download-link-certificate"  v-if="product.ProductCertificate3" :href="getDownloadCertURL(product.ProductCertificate3, '3')">Certificate3</a>
                <a id="download-link-certificate"  v-if="product.ProductCertificate4" :href="getDownloadCertURL(product.ProductCertificate4, '4')">Certificate4</a> -->

                <!-- <a id="download-link-pics" v-if="product.ProductPICS1" @click="downloadPICS(product.ProductID, product.ProductPICS1, '1')">PICS1</a>
                <a id="download-link-pics" v-if="product.ProductPICS2" @click="downloadPICS(product.ProductID, product.ProductPICS1, '2')">PICS2</a>
                <a id="download-link-pics" v-if="product.ProductPICS3" @click="downloadPICS(product.ProductID, product.ProductPICS1, '3')">PICS3</a>
                <a id="download-link-pics" v-if="product.ProductPICS4" @click="downloadPICS(product.ProductID, product.ProductPICS1, '4')">PICS4</a>

                <a id="download-link-certificate"  v-if="product.ProductCertificate1" @click="downloadCertificate(product.ProductID, product.ProductCertificate1, '1')">Certificate1</a>
                <a id="download-link-certificate"  v-if="product.ProductCertificate2" @click="downloadCertificate(product.ProductID, product.ProductCertificate2, '2')">Certificate2</a>
                <a id="download-link-certificate"  v-if="product.ProductCertificate3" @click="downloadCertificate(product.ProductID, product.ProductCertificate3, '3')">Certificate3</a>
                <a id="download-link-certificate"  v-if="product.ProductCertificate4" @click="downloadCertificate(product.ProductID, product.ProductCertificate4, '4')">Certificate4</a> -->

              </span>
            </li>
            <!-- <li class="card-text">
              <ul class="card-links">
                <li>
                  <router-link
                    :to="`product-page/${product.ProductIdentifier}`"
                    class="nav-link"
                  >View Product</router-link>
                </li>
                <li>
                  <router-link
                    :to="`/admin/edit-products/${product.ProductIdentifier}`"
                    class="nav-link"
                    v-if="admin_page"
                  >Edit Product</router-link>
                </li>
                <li>
                  <router-link
                    :to="`product-page/${product.ProductIdentifier}`"
                    class="nav-link"
                  >Download Certificate</router-link>
                </li>
              </ul>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
    <div class="loader" v-if="apiLoading"></div>
    <!-- <div class="pagination" id="top-buttons">
      <button
        type="button"
        class="btn btn-primary"
        :disabled="!hasPrevious"
        @click="previousPage"
      >Previous Page</button>
      <button type="button" class="btn btn-primary" :disabled="!hasNext" @click="nextPage">Next Page</button>
    </div>
    <div class="pagination" id="bottom-buttons">
      <button
        type="button"
        class="btn btn-primary"
        :disabled="!hasPrevious"
        @click="previousPage"
      >Previous Page</button>
      <button type="button" class="btn btn-primary" :disabled="!hasNext" @click="nextPage">Next Page</button>
    </div>-->
    <!-- <component-pagination class="pagination" id="top-buttons"></component-pagination> -->
  </div>
</template>

<script>
import Pagination from "./Pagination.vue";
import axios from "axios";
import FileSaver from 'file-saver';
import xlsx from 'xlsx';
import constants from "../constants.js";

// import constants from "./constants.js";

export default {
  props: ["admin_page"],
  beforeCreate() {
    this.$store.commit("callAPI");
  },
  data() {
    return {
      image_src: null
    }
  },
  computed: {
    apiData() {
      let apiData = this.$store.state.apiData
      // console.log(apiData)
      return apiData
    },
    apiLoading() {
      return this.$store.state.apiLoading;
    },
    hasNext() {
      return this.$store.state.hasNext;
    },
    hasPrevious() {
      return this.$store.state.hasPrevious;
    },
    productCount() {
      return this.$store.state.productCount;
    },
    // currentPage() {
    //   return this.$store.state.currentPage;
    // },
    dataReady() {
      return this.$store.state.dataReady;
    }
  },
  methods: {
    getDownloadPICSURL(filename) {
      let url = filename.replace('/api/v1/products/uploads','')
      // get rid of trailing slash
      url = url.slice(0, url.length)
      return url
    },
    getDownloadCertURL(filename) {
      let url = filename.replace('/api/v1/products/uploads','')
      // get rid of trailing slash
      url = url.slice(0, url.length)
      return url
    },
    getLogoURL(filename) {
      let url = filename.replace('/api/v1/products/uploads','')
      // get rid of trailing slash
      url = url.slice(0, url.length)
      // console.log(url)
      return url
    },
    getCert(filename) {
      let url = filename.replace('/api/v1/products/uploads','')
      // get rid of trailing slash
      url = url.slice(0, url.length)
      let _filename = url.slice(url.lastIndexOf('/') + 1, url.length)
      // console.log('filename: ' + _filename)
      axios({
            url: url,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement('a');

              fileLink.href = fileURL;
              fileLink.setAttribute('download', _filename);
              document.body.appendChild(fileLink);

              fileLink.click();
        });
    },
    noDownloadCheck(filename) {
      if (filename) {
        return false
      } else {
        return true
      }
    },
    getProductLogoPath(productLogoPath) {
      console.log('getproductlogopath: ')
      console.log(productLogoPath)
      let ret_str = productLogoPath.replace('https://certifications.sunspec.org/api/v1/products/uploads/logos/', '')
      // let ret_str = productLogoPath.replace('http://127.0.0.1:8000/api/v1/products/uploads/logos/', '')

      // console.log('logo path: ')
      // console.log(productLogoPath)
      if (ret_str.includes("_")) {
        let first_index = ret_str.indexOf("_")
        let second_index = ret_str.indexOf(".")
        let length = ret_str
        ret_str = ret_str.slice(0, first_index) + ret_str.slice(second_index)
        // console.log(ret_str)
      }
      return './../company_logos/' + ret_str
    },
    getLogoFile(logoPath) {
        // console.log('logo path: ')
        // console.log(logoPath)
        // let logo_file_name = logoPath.replace('http://127.0.0.1:8000/api/v1/products/uploads/logos/', '')

        // let url = "http://127.0.0.1:8000/api/v1/downloadLogo/" + logoPath + "/"
        let url = constants.API_ENDPOINT.replace('products','downloadLogo/')
        url = url + logoPath + "/"
        console.log(url)
        let img_src = ''

        axios
          .get(url, {
            headers: {
              Authorization: "Token 7efbd44a97989e4cfae99715eb3e2435d86ad5df"
            }
          }).then(response => {
            // console.log(response)
            let img_src = 'data:image/png;base64,' + response.data
            console.log('ret check in')
            return img_src
          })

        // while (!img_src) {}
        // console.log(img_src)
        
    },
    nextPage() {
      this.$store.commit("toggleAPILoading");
      return this.$store.commit("callAPI", this.$store.state.nextPage);
    },
    previousPage() {
      this.$store.commit("toggleAPILoading");

      return this.$store.commit("callAPI", this.$store.state.previousPage);
    },
    downloadPICS(ProductID, filename, certnum) {
      // console.log(filename)
      if (filename) {
        // let xlsx_filename = filename.replace("https://certifications.sunspec.org/api/v1/products/uploads/PICS/", "")
        let xlsx_filename = filename.replace("http://127.0.0.1:8000/api/v1/products/uploads/PICS/", "")

        // console.log("downloadPICS file name: ")
        // console.log(xlsx_filename)
        // let url = "https://certifications.sunspec.org/api/v1/downloadPICS/" + ProductID + "/" + certnum + "/"
        let url = constants.API_ENDPOINT.replace('products','downloadPICS/')
        url = url + ProductID + "/" + certnum + "/"

        axios
          .get(url, {
            headers: {
              Authorization: "Token 7efbd44a97989e4cfae99715eb3e2435d86ad5df"
            }
          }).then(response => {
            // console.log(response.data)

            let wb = xlsx.read(response.data, {type: 'base64'})
            // console.log(xlsx_filename)
            xlsx.writeFile(wb, `${xlsx_filename}`);
          })
      }
    },
    downloadCertificate(ProductID, filename, certnum) {
      // console.log(filename)
      // let url = "https://certifications.sunspec.org/api/v1/downloadCertificate/" + ProductID + "/" + certnum + "/"
      let url = constants.API_ENDPOINT.replace('products','downloadCertificate/')
      url = url + ProductID + "/" + certnum + "/"

      if (filename) {
        axios
          .get(url, {
            headers: {
              Authorization: "Token 7efbd44a97989e4cfae99715eb3e2435d86ad5df"
            }
          }).then(response => {
            //file-saver try
            const binaryString = window.atob(response.data);
            const len = binaryString.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; ++i) {
              bytes[i] = binaryString.charCodeAt(i);
            }
            var file = new Blob([bytes], { type: 'application/pdf' })
            // let pdf_name = filename.replace("https://certifications.sunspec.org/api/v1/products/uploads/Certificates/", "")
            let pdf_name = filename.replace("http://127.0.0.1:8000/api/v1/products/uploads/Certificates/", "")

            // console.log("pdf name: ")
            // console.log(pdf_name)
            saveAs(file, pdf_name);
        })
      }
    },
    // renderLogo(ProductID) {
    //   // console.log("certs: " + ProductID)
    //   let url = "http://localhost:8000/api/v1/downloadLogo/efe92c87-2415-43d9-a5f4-a5f617aa6689/"
    //   axios
    //     .get(url, {
    //       headers: {
    //         Authorization: "Token 7efbd44a97989e4cfae99715eb3e2435d86ad5df"
    //       }
    //     }).then(response => {
    //       // console.log(response.data)
    //       this.image_src = "data:image/png;base64," + response.data
    //     }) 
    // }
  },
  components: {
    "component-pagination": Pagination
  }
};
</script>

<style scoped>
.btn {
  margin: 5px;
}
.product-public-list-container {
  display: grid;
  grid-template-rows: 50px 705px 75px;
  grid-template-columns: auto;
  height: 100%;
}

li {
  margin-top: -6px;
  margin-bottom: -6px;
}
ul {
  padding: 0;
  list-style: none;
}

.card {
  border: 2px solid #444549;
  box-shadow: 3px 3px 8px 0px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  height: 227px;
  width: 488px;
  padding: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  display: grid;
  grid-template-columns: 33% 1fr;
  grid-template-rows: 140px auto;
}

.logo {
  width: 140px;
  height: 140px;

}

.card-body {
  padding: 0;
  grid-column: 2 / 3;
  grid-row: 1 / span 2;
  overflow-y: auto;
  height: 100%;
}

.product-public-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background-color: #f8f8f8;
  height: 725px;
  justify-content: flex-start;
  align-content: flex-start;
  grid-row: 2 / 3;
  grid-column: 1 /2;
}

a.nav-link {
  padding: 0px;
}

.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  margin-left: 400px;
  margin-top: 150px;
  grid-row: 2 / 3;
  grid-column: 1 /2;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

#top-buttons {
  grid-row: 1 / 2;
  margin-top: -20px;
  margin-right: 38px;
}

#bottom-buttons {
  grid-row: 3 / 4;
  margin-top: -20px;
  margin-right: 38px;
}

.pagination-container {
  margin-top: -19px;
  margin-left: 685px;
  grid-row: 1 / 2;
}

.btn-primary,
.btn-primary:hover,
.btn-primary:active,
.btn-primary:visited,
.btn-primary:focus,
.btn-primary:disabled {
  background-color: #1d4679;
  border-color: #1d4679;
}

a {
  color: #1d4679;
}

.download-links-container {
  width: 250px;
  display: inline-flex;
  flex-wrap: wrap;
  width: 100%;
}

#download-link-pics {
  margin-left: 5px;
  color: #0645AD !important;
}

#download-link-pics:hover {
  text-decoration: underline;
  cursor: pointer;
}

#download-link-certificate {
  margin-left: 5px;
  color: #0645AD !important;
}

#download-link-certificate:hover {
  text-decoration: underline;
  cursor: pointer;
}

#logo_rendered {
  width: 140px;
  height: 140px;
}

.no-download {
  text-decoration: line-through !important;
  cursor: default !important;
}

.no-download:hover {
  cursor: none;
  text-decoration: line-through !important;
  cursor: default !important;
}

</style>